import {bound} from "./framework/voidash.js";
import {FSM, FSMTransitionTable} from "./fsm";
import {addClass, removeClass} from "./utils";

const STATE_OFF = 0;
const STATE_WAITING = 1;
const STATE_ACTIVE_FORCED = 2;
const STATE_ACTIVE_WAITING = 3;
const STATE_ACTIVE_FREE = 4;
const STATE_INVALID = FSM.NOOP;

const ACT_OFF = 0;
const ACT_ON = 1;
const ACT_DELAY = 2;
const ACT_ELAPSED = 3;

const transitionTable = new FSMTransitionTable({ invalidState: STATE_INVALID });

const defTrans = bound(transitionTable, "addTransition");

defTrans(STATE_OFF, ACT_OFF, STATE_OFF);
defTrans(STATE_OFF, ACT_ON, STATE_WAITING);

defTrans(STATE_WAITING, ACT_OFF, STATE_OFF);
defTrans(STATE_WAITING, ACT_ON, STATE_WAITING);
defTrans(STATE_WAITING, ACT_DELAY, STATE_ACTIVE_FORCED);

defTrans(STATE_ACTIVE_FORCED, ACT_OFF, STATE_ACTIVE_WAITING);
defTrans(STATE_ACTIVE_FORCED, ACT_ELAPSED, STATE_ACTIVE_FREE);
defTrans(STATE_ACTIVE_FORCED, ACT_ON, STATE_ACTIVE_FORCED);
defTrans(STATE_ACTIVE_FORCED, ACT_DELAY, STATE_ACTIVE_FORCED);

defTrans(STATE_ACTIVE_WAITING, ACT_ELAPSED, STATE_OFF);
defTrans(STATE_ACTIVE_WAITING, ACT_OFF, STATE_ACTIVE_WAITING);
defTrans(STATE_ACTIVE_WAITING, ACT_ON, STATE_ACTIVE_FORCED);

defTrans(STATE_ACTIVE_FREE, ACT_OFF, STATE_OFF);
defTrans(STATE_ACTIVE_FREE, ACT_ON, STATE_ACTIVE_FREE);

export default class ClassDelayedToggler {
  constructor(opts) {
    this.opts = opts;

    this.fsm = new FSM({
      table: transitionTable,
      onTransition: (...args) => this._handleTransition(...args)
    });

    this.onCallback = null;
    this.offCallback = null;
  }

  _handleTransition(state, prevState, input) {
    const delay = () => { this.fsm.input(ACT_DELAY); };

    const duration = () => { this.fsm.input(ACT_ELAPSED); };

    switch(state) {
      case STATE_OFF:
        if (this.offCallback) {
          this.offCallback();
          this.offCallback = null;
        }
        removeClass(this.opts.el, this.opts.className);
        break;

      case STATE_ACTIVE_FORCED:
        addClass(this.opts.el, this.opts.className);
        if (this.onCallback) {
          this.onCallback();
          this.onCallback = null;
        }
        if(prevState === STATE_WAITING) setTimeout(duration, this.opts.duration);
        break;

      case STATE_WAITING:
        setTimeout(delay, this.opts.delay);
        break;
    }

    // console.log(prevState + " + " + input + " -> " + state);
  }

  on(cb) { this.onCallback = cb; this.fsm.input(ACT_ON); }

  off(cb) { this.offCallback = cb; this.fsm.input(ACT_OFF); }
}

